import { type RouterState, useRouter as useFoundRouter } from 'found';

import { useResolvedMatch } from './useResolvedMatch';

/**
 * found's own `useRouter` with the resolved-match filter applied. Import this
 * rather than found's hooks directly: `useRouter`, `useMatch`, `useParams` and
 * `useLocation` all read found's raw router context, which carries the pending
 * match. `./withRouter` is the HOC counterpart.
 */
const useRouter = (): RouterState => {
	const { router, match } = useFoundRouter();
	return { router, match: useResolvedMatch(match) };
};

export default useRouter;
